import classNames         from 'classnames';
import * as React         from 'react';
import { useTranslation } from 'react-i18next';
import DV                 from 'ts-data-validator';

import Dropdown        from '../../../components/fields/dropdown';
import LoupeIcon       from '../../../components/icons/LoupeIcon';
import SearchCrossIcon from '../../../components/icons/SearchCrossIcon';

const WhereBuyNavigation = function(props) {
  const { t } = useTranslation();

  const {
          cities,
          currentCity,
          currentRegion,
          getFullAddress,
          handleChangeCity,
          handleChangeRegion,
          highlight,
          regions,
          searchQuery,
          setSearchQuery,
          tradeStores,
        } = props;

  const searchInputRef        = React.useRef(null);
  const storeResultWrapperRef = React.useRef(null);

  const [isSearchOpen, setIsSearchOpen] = React.useState(false);

  const filteredTradeStores = React.useMemo(() => {
    if (!searchQuery) {
      return [];
    }

    const query = searchQuery
      .trim()
      .escapeChars();

    const regex = new RegExp(query, 'gi');

    return tradeStores
      .map((tradeStore) => {
        const fullAddress = getFullAddress(tradeStore);

        return {
          ...tradeStore,
          fullAddress,
          highlighted: fullAddress.replace(regex, (match) => {
            return `<span class="highlight">${match}</span>`;
          }),
        };
      })
      .filter((store) => store.highlighted !== store.fullAddress);
  }, [getFullAddress, searchQuery, tradeStores]);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        storeResultWrapperRef.current &&
        !storeResultWrapperRef.current.contains(event.target) &&
        searchInputRef.current &&
        !searchInputRef.current.contains(event.target)
      ) {
        setIsSearchOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className={'bg-gray'}>
      <div className={'dropdown_container'}>
        <Dropdown
          labelKey={'label'}
          onChangeCallback={handleChangeRegion}
          options={regions}
          placeholder={t('client_allRegions')}
          required={false}
          selected={currentRegion?.regionId}
          valueKey={'regionId'}
        />
        {currentRegion && (
          <Dropdown
            labelKey={'label'}
            onChangeCallback={handleChangeCity}
            options={cities}
            placeholder={t('client_allCities')}
            required={false}
            selected={currentCity?.cityId}
            valueKey={'cityId'}
          />
        )}
      </div>
      <div
        className={classNames('search_wrapper', {
          open:      isSearchOpen,
          with_text: searchQuery.length,
        })}
      >
        <input
          className={'search_input'}
          onChange={(event) => {
            setSearchQuery(event.target.value);
            setIsSearchOpen(true);
          }}
          placeholder={t('placeholder_find_salon')}
          ref={searchInputRef}
          type={'text'}
          value={searchQuery}
        />
        <LoupeIcon />
        <div
          onClick={() => {
            setSearchQuery('');
            setIsSearchOpen(false);
          }}
        >
          <SearchCrossIcon />
        </div>
        <div
          className={'store_result_wrapper'}
          ref={storeResultWrapperRef}
        >
          {filteredTradeStores.map((tradeStore) => {
            return (
              <p
                className={'item'}
                dangerouslySetInnerHTML={{
                  __html: tradeStore.highlighted,
                }}
                key={tradeStore.tradeStoreId}
                onClick={() => {
                  setSearchQuery(tradeStore.fullAddress);
                  handleChangeCity(tradeStore.cityId);
                  highlight(tradeStore);
                  setIsSearchOpen(false);
                }}
              />
            );
          })}
          {!filteredTradeStores.length && <p className={'item_not_found'}>{t('client_salon_not_found')}</p>}
        </div>
      </div>
    </div>
  );
};

export default WhereBuyNavigation;